module.exports = __webpack_public_path__ + "yz/media/ruku-fail.cc22b3b4.mp3";